class FeaturedBlog {
  constructor(container) {
    this.container = container;
    this.slider = container.querySelector('slider-component');
    this.viewAllButton = container.querySelector('#ViewAll-' + container.dataset.sectionId);
    this.mobileViewAllLink = container.querySelector('.featured-blog__view-all-mobile');
    this.postsList = container.querySelector('.blog__posts');
    this.postLimit = parseInt(container.dataset.postLimit) || 3;
    this.allPosts = Array.from(container.querySelectorAll('.blog__post'));
    this.isExpanded = false;

    this.init();
  }

  init() {
    if (this.viewAllButton) {
      this.viewAllButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.showAllPosts();
      });
    }

    if (this.mobileViewAllLink) {
      this.mobileViewAllLink.addEventListener('click', (e) => {
        e.preventDefault();
        this.showAllPosts();
      });
    }
  }

  showAllPosts() {
    if (this.isExpanded) return;

    this.isExpanded = true;

    // 全ての記事を表示
    this.allPosts.forEach((post, index) => {
      // まず表示状態にする
      post.style.display = '';
      post.classList.remove('slider__slide');
      post.classList.remove('blog__post--hidden');
      
      // アニメーション用の遅延を追加
      requestAnimationFrame(() => {
        setTimeout(() => {
          post.style.opacity = '0';
          post.style.transition = 'opacity 0.3s ease-in-out';
          requestAnimationFrame(() => {
            post.style.opacity = '1';
          });
        }, index * 50);
      });
    });

    // スライダーを無効化
    if (this.slider) {
      this.slider.classList.add('slider--disabled');
      const sliderButtons = this.slider.querySelector('.slider-buttons');
      if (sliderButtons) {
        sliderButtons.style.display = 'none';
      }
    }

    // ボタンを非表示
    if (this.viewAllButton) {
      const buttonContainer = this.viewAllButton.closest('.blog__view-all');
      if (buttonContainer) {
        buttonContainer.style.display = 'none';
      }
    }
    if (this.mobileViewAllLink) {
      this.mobileViewAllLink.style.display = 'none';
    }

    // リストのクラスを更新してグリッド表示に
    if (this.postsList) {
      this.postsList.classList.remove('slider');
      this.postsList.classList.remove('slider--tablet');
      this.postsList.classList.remove('slider--mobile');
    }
  }
}

// 初期化
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-featured-blog]').forEach((container) => {
    new FeaturedBlog(container);
  });
});

